import { clone } from "@SyoLab/utils"

export function getServiceDataObject(data = {}, settings2 = {}) {
   data = clone(data)
   data.settings = { ...data.settings, ...settings2, }

   return {
      _id: null,
      type: 'subscription',
      name: null,
      project_id: null,
      projectName: null,
      customer_id: null,
      customerName: null,
      notBillable: false,
      serviceType: null,
      color: null,
      accountNo: null,
      businessDomain: null,
      value: 0,
      // status
      status: null,
      assignedTo: [],
      // serviceData
      services: [],
      config: {},
      settings: {},
      createdBy: null,
      createdTimeStamp: null,
      userId: null,
      timeStamp: null,
      order: null, // sorting order
      // billing
      billingText: null,
      billNo: null,
      billingTimestamp: null,
      billedBy: null,
      // subscription
      subscription_id: null,
      startDate: null,
      endDate: null,
      domain: null,
      ...data
   }
}